import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth, SESSION_KEY } from "@/context/AuthContext";
import { toast } from "sonner";

const announce = (u) => { try { localStorage.setItem(SESSION_KEY, JSON.stringify({ id: u.id, at: Date.now() })); } catch { /* storage unavailable */ } };

/** Start a sandbox or hop between its sample client and clinician. Demo accounts are never remembered in the account switcher. */
export function useDemo() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const enter = (u) => {
    setUser(u);
    announce(u);
    sessionStorage.removeItem("hc_tab");
    sessionStorage.removeItem("hc_ctab");
    navigate(u.role === "clinician" ? "/clinician" : "/client");
  };

  const run = async (path, view, okMsg) => {
    setBusy(true);
    try {
      const { data } = await api.post(path, { view });
      enter(data);
      if (okMsg) toast.success(okMsg, { duration: 5000 });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return {
    busy,
    start: (view = "client") => run("/demo/start", view, view === "clinician" ? "You're viewing a sample caseload. Nothing here is real." : "Welcome to the demo garden — try a check-in."),
    switchTo: (view) => run("/demo/switch", view),
  };
}
